// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Hux3r","head":"ProcedureTableInfo_head__3zOcn"};